import React, { Component } from 'react';
import { MuiThemeProvider,createMuiTheme } from 'material-ui/styles';
import './App.css';
// Components
import AppTopBar from './Components/AppTopBar';
import AppView from './Components/AppView';
//connect
import {connect} from 'react-redux';


// Theme config
const palette = {
  primary: {
    light: "#4bb285",
    main: "#2ba46f",
    dark: "#20925c",
    contrastText: "#4d4d4d",
  },
  secondary: {
    light: '#ff7961',
    main: "#c9e2be",
    dark: "#dfedd8",
    contrastText: "#02984a",
  },
};
const theme = createMuiTheme({
  palette: palette,
  typography:  {
    fontFamily: "'Lato'"
  }
});


class AppClass extends Component {
  constructor(props){
    super(props)
  }
  render() {
    if(this.props.loading){
      return (<div className="loading-bg flex flex-auto layout-column justify-center">
                
                <div className="sk-folding-cube">
                  <div className="sk-cube1 sk-cube"></div>
                  <div className="sk-cube2 sk-cube"></div>
                  <div className="sk-cube4 sk-cube"></div>
                  <div className="sk-cube3 sk-cube"></div>
                </div>
              </div>
            )
    }
    return (
      <MuiThemeProvider theme={theme}>
        <AppTopBar/>
        <AppView quote={this.props.currentQuote}/>
        
      </MuiThemeProvider>
    );
  }
}


const mapStateToProps = (state, ownProps) =>{
  return {
    currentQuote: state.currentQuote,
    loading: state.asyncInitialState.loading
  }
}

const App = connect(
  mapStateToProps
)(AppClass)

export default App;



// WEBPACK FOOTER //
// ./src/App.js